import { Button, Modal } from "antd";
import { useState } from "react";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Layout from "../../Components/Layout/Layout";
import styles from "./ThinkGreen.module.scss";
import { tg_data } from "./data";
import modal_cross from "./images/modal_cross.svg";
import think_green_banner from "./images/think_green_banner.jpeg";

const ThinkGreen = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [activeExpandIndex, setActiveExpandIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState({
        image: "",
        title: "",
        description: () => {},
    });

    return (
        <Layout title="Think Green">
            <div className="container">
                <BreadCrumb
                    list={[
                        { name: "Home", link: "/" },
                        { name: "Sustainability", link: "/think-green" },
                    ]}
                />
            </div>
            <img src={think_green_banner} alt="think_green_banner" className="img-fluid " />
            <div className={styles.think_green_container}>
                <h2 className={styles.title}>Fresh for Today & Green for Tomorrow</h2>

                <p className="text-center fs-3 ">
                    At Desi fresh, we believe in making positive impact on our <strong>environment</strong>, <strong>communities</strong>{" "}
                    and <strong>customers</strong>. Today, we are taking significant steps towards building a sustainable future by offering
                    a diverse range of fair products, supporting social projects, and implementing innovating measures.
                </p>

                <h3
                    className={`text-center fs-1`}
                    style={{
                        color: "var(--color-primary)",
                    }}
                >
                    Focus Topics
                </h3>

                <div className="row g-5 mb-5">
                    {tg_data.map((item, index) => (
                        <div className="col-md-6" key={index}>
                            <img src={item.image} alt="banner" className="img-fluid" loading="lazy" />
                            <h3 className="text-center text-primary mt-3">{item.title}</h3>

                            {isExpanded && index === activeExpandIndex ? (
                                <div className="px-2">
                                    <div>{item.description()}</div>
                                    <div className="mt-3 d-flex justify-content-center w-100">
                                        <Button
                                            onClick={() => {
                                                if (window.innerWidth < 576) {
                                                    setIsExpanded(false);
                                                }
                                            }}
                                            type="primary"
                                        >
                                            Read Less
                                        </Button>
                                    </div>
                                </div>
                            ) : (
                                <div className="px-2">
                                    <div className={styles.tg_desc_clamp}>{item.description()}</div>
                                    <div className="mt-3 d-flex justify-content-center w-100">
                                        <Button
                                            onClick={() => {
                                                if (window.innerWidth < 576) {
                                                    setIsExpanded(true);
                                                    setActiveExpandIndex(index);
                                                } else {
                                                    setIsModalOpen(true);
                                                    setModalData(item);
                                                }
                                            }}
                                            type="primary"
                                        >
                                            Learn More
                                        </Button>
                                    </div>
                                </div>
                            )}

                            <Modal
                                open={isModalOpen}
                                onCancel={() => {
                                    setIsModalOpen(false);
                                }}
                                centered
                                footer={null}
                                width={window.innerWidth < 576 ? "90%" : "50%"}
                                closeIcon={
                                    <img
                                        src={modal_cross}
                                        alt="close"
                                        className="img-fluid"
                                        style={{
                                            height: 32,
                                        }}
                                    />
                                }
                                destroyOnClose
                            >
                                <div className="d-flex flex-column">
                                    <img src={modalData.image} alt="cause_pic" className="img-fluid" loading="lazy" height={40} />
                                    <div className="text-primary fs-2 fw-bold mt-3 text-center ">{modalData.title}</div>
                                    <div>{modalData.description()}</div>
                                </div>
                            </Modal>
                        </div>
                    ))}
                </div>
            </div>
        </Layout>
    );
};

export default ThinkGreen;
